import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import AdvertisementCreateView from "../views/AdvertisementCreateView";
import AdvertisementCreateViewStore from "../../stores/AdvertisementCreateViewStore";
import SavingStates from "../../constants/states/SavingStates";
import ImageUploaderStore from "../../stores/ImageUploaderStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";

class AdvertisementCreateContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "advertisementCreateViewStoreState": AdvertisementCreateViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        };
    }

    componentDidMount() {
        this.advertisementCreateViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_CREATE_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        this.imageUploaderStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.IMAGE_UPLOADER_STORE_UPDATED, this.handleStoreUpdate);
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.advertisementCreateViewStoreSubscriber);
        EventPublisher.unsubscribe(this.imageUploaderStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.REST_IMAGE_STORE, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementCreateViewStoreState": AdvertisementCreateViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        });
    };

    render() {
        return (
            <AdvertisementCreateView
                isSaving={this.state.advertisementCreateViewStoreState.savingState === SavingStates.SAVING}
                showingImageSlideIndex={this.state.imageUploaderStore.currentShownImageIndex}
                title={this.state.advertisementCreateViewStoreState.title}
                description={this.state.advertisementCreateViewStoreState.description}
                imageNames={this.state.imageUploaderStore.imageNames}
                uploadPercentage={this.state.imageUploaderStore.currentUploadPercentage()}
            />
        );
    }

}

export default AdvertisementCreateContainer;